export enum TimeEntryTypeKey {
  ESTATE_WORK = 'estate_work',
  CEI = 'cei',
  PTO = 'pto',
  NON_WORK_RELATED = 'non_work_related'
}
